import api from '../http';

export default class StatisticsService {
    static async kosa() {
        return api.get('/statistics/kosa');
    }
}
